import * as types from './mutation-types'
import { BOOTSTRAP_CURRENT_USER } from "@/store/modules/user/mutation-types"
import { ADD_TIMEZONES, ADD_OPENING_DAYS } from "@/store/modules/timezone/mutation-types"

export default {
    bootstrap ({ commit, dispatch, state }) {
        return new Promise((resolve, reject) => {
            window.axios.get('/bootstrap').then((response) => {
                commit(types.UPDATE_APP_LOADING_STATUS, true)
                commit('user/' + BOOTSTRAP_CURRENT_USER, response.data.user, {root: false})
                commit('timezone/' + ADD_TIMEZONES, response.data.timezones, {root: false})
                commit('timezone/' + ADD_OPENING_DAYS, response.data.openingDays, {root: false})
                commit(types.CALL_TABLES, response.data.tables)
                resolve(response)
            }).catch((err) => {
                reject(err)
            })
        })
    },

    dashboard ({ commit, dispatch, state }) {
        return new Promise((resolve, reject) => {
            window.axios.get('/dashboard').then((response) => {
                // commit(types.UPDATE_APP_LOADING_STATUS, true)
                // commit('user/' + BOOTSTRAP_CURRENT_USER, response.data.user, {root: false})
                // commit('timezone/' + ADD_TIMEZONES, response.data.timezones, {root: false})
                // commit('timezone/' + ADD_OPENING_DAYS, response.data.openingDays, {root: false})
                // commit(types.CALL_TABLES, response.data.tables)
                resolve(response)
            }).catch((err) => {
                reject(err)
            })
        })
    }
}